import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCheckout } from "../hooks/api";
import { OverviewGrid, CheckoutSection } from "../components";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ContactAndPaymentOverviewSection = ({ options, }) => {
    const { data } = useCheckout();
    return (_jsx(CheckoutSection, { children: _jsx(OverviewGrid, { items: [
                {
                    title: "Kontakt",
                    content: (_jsxs("p", { children: [data?.data.contactAddressFirstName, " ", data?.data.contactAddressLastName, _jsx("br", {}), data?.data.contactAddressStreet, " ", data?.data.contactAddressStreetNumber, _jsx("br", {}), data?.data.contactAddressZipCode, " ", data?.data.contactAddressPlace] })),
                },
                ...(!options?.hideShippingAddress
                    ? [
                        {
                            title: "Lieferadresse",
                            content: data?.data.differingShippingAddress ? (_jsxs("p", { children: [data?.data.shippingAddressFirstName, " ", data?.data.shippingAddressLastName, _jsx("br", {}), data?.data.shippingAddressStreet, " ", data?.data.shippingAddressStreetNumber, _jsx("br", {}), data?.data.shippingAddressZipCode, " ", data?.data.shippingAddressPlace] })) : ("Entspricht Kontaktadresse"),
                        },
                    ]
                    : []),
                {
                    title: "Bezahlung",
                    content: (_jsxs(_Fragment, { children: [_jsxs("p", { children: ["IBAN: ", data?.data.iban] }), _jsxs("p", { children: ["Bank: ", data?.data.bank] })] })),
                },
            ] }) }));
};
